import { Injectable } from "@angular/core";
import { IID_OLO_DEACTIVATION_PHYSIC } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolDeactivationPhysicStore } from "./iidOlDeactivationPhysic.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';



@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.OLO_DEACTIVATION_PHYSIC)
export class IIDolDeactivationPhysicQuery extends AbstractInterfaceDataQuery<IID_OLO_DEACTIVATION_PHYSIC> {

  constructor(protected store: IIDolDeactivationPhysicStore) {
    super(store);
  }
}
